<div class="club-of-cards" [ngClass]="{'club-of-cards1':widgetDetails?.length<3}">
    <div *ngFor="let widget of widgetDetails, let i = index " [ngSwitch]="widget?.name"
        [ngClass]="{'no-padding': widget?.name === 'Route details' , 'club-of-cards3': i === 2 && widgetDetails?.length === 3 }"
        [style.width.%]="widget?.attributes?.widthInPercentage"
        [style.height.%]="widget?.attributes?.heightInPercentage">
        <div *ngSwitchCase="'Vehicle Score'">
            <app-vehicle-score [entityId]="entityId" [widgetData]="{title:widget?.title}"></app-vehicle-score>
        </div>
        <div *ngSwitchCase="'Certificate Details'">
            <app-reminders [entityId]="entityId" [widgetData]="{title:widget?.title}"></app-reminders>
        </div>
        <div *ngSwitchCase="'Route details'" class="d-flex align-items-center">
            <app-route [entityId]="entityId" [widgetCount]="widgetDetails?.length" class="h-100 w-100 z-0" [fromDate]="fromDate" [toDate]="toDate"></app-route>
        </div>
        <div *ngSwitchCase="'Driver details'">
            <app-driver-details [entityId]="entityId" [widgetData]="{title:widget?.title}">
            </app-driver-details>
        </div>
        <div *ngSwitchCase="'Asset Health'">
            <app-asset-health [entityId]="entityId" [widgetData]="{title:widget?.title}">
            </app-asset-health>
        </div>
        <div *ngSwitchCase="'Asset Condition'">
            <app-asset-condition [entityId]="entityId" [widgetData]="{title:widget?.title}">
            </app-asset-condition>
        </div>
        <div *ngSwitchCase="'Activity Level'" class="d-grid">
            <app-activity-level [entityId]="entityId" class="d-grid"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-activity-level>
        </div>
        <div *ngSwitchCase="'Device'" class="d-grid">
            <app-device [entityId]="entityId" [uniqueId]="masterEntitiesData?.uniqueId"
                [entityDetails]="masterEntitiesData" class="d-grid"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-device>
        </div>
        <div *ngSwitchCase="'Skin Temperature'" class="position-relative">
            <app-skin-temperature [entityId]="entityId" [config]="attributeThreshold"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-skin-temperature>
        </div>
        <div *ngSwitchCase="'Respiratory Rate'" class="position-relative">
            <app-respiratory-rate [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}"
                [config]="attributeThreshold">
            </app-respiratory-rate>
        </div>
        <div *ngSwitchCase="'Tagged Destination'" class="d-grid">
            <app-tagged-destination [entityDetails]="masterEntitiesData" [siteId]="siteId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}" class="d-grid">
            </app-tagged-destination>
        </div>
        <div *ngSwitchCase="'Live Status'" class="position-relative">
            <app-monotainer-live-status [entityId]="entityId" [siteId]="masterEntitiesData?.site?._id"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-monotainer-live-status>
        </div>
        <div *ngSwitchCase="'bph'" class="position-relative">
            <app-bph [entityId]="entityId" [siteId]="masterEntitiesData?.site?._id"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-bph>
        </div>
        <div *ngSwitchCase="'cph'" class="position-relative">
            <app-cph [entityId]="entityId" [siteId]="masterEntitiesData?.site?._id"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title}">
            </app-cph>
        </div>
        <div *ngSwitchCase="'temperature'" class="position-relative">
            <app-dmk-common [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'Temperature °F', widgetDataAttributes: widget?.dataAttributes }">
            </app-dmk-common>
        </div>
        <div *ngSwitchCase="'humidity'" class="position-relative">
            <app-dmk-common [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'Humidity', widgetDataAttributes: widget?.dataAttributes}">
            </app-dmk-common>
        </div>
        <div *ngSwitchCase="'battery'" class="position-relative">
            <app-dmk-common [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'Battery Status', widgetDataAttributes: widget?.dataAttributes}">
            </app-dmk-common>
        </div>
        <div *ngSwitchCase="'avgScanTime'" class="position-relative">
            <app-avg-scan-time [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-avg-scan-time>
        </div>
        <div *ngSwitchCase="'transactionsPerDay'" class="position-relative">
            <app-transactions-per-day [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-transactions-per-day>
        </div>
        <div *ngSwitchCase="'scansForTheDay'" class="position-relative">
            <app-scans-per-day [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-scans-per-day>
        </div>
        <div *ngSwitchCase="'timeToHitThreshold'" class="position-relative">
            <app-time-to-hit-threshold [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-time-to-hit-threshold>
        </div>
        <div *ngSwitchCase="'averageProductOnboardingTime'" class="position-relative">
            <app-average-product-onboarding-time [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-average-product-onboarding-time>
        </div>
        <div *ngSwitchCase="'health'" class="position-relative">
            <app-health [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:''}">
            </app-health>
        </div>
        <div *ngSwitchCase="'gauge-widget'" class="position-relative">
            <app-common-gauge [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate: widget?.attributes?.refreshRate, title: widget?.title, widgetDataAttributes: widget?.dataAttributes}">
            </app-common-gauge>
        </div>
        <div *ngSwitchCase="'text-widget'" class="position-relative">
            <app-common-text [entityDetails]="masterEntitiesData" [entityId]="entityId" [widgetData]="widget">
            </app-common-text>
        </div>
        <div *ngSwitchCase="'Acceleration'" class="position-relative">
            <app-common-line [widgetType]="'acceleration'" [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, widgetDataAttributes: widget?.dataAttributes, name: widget?.name}">
            </app-common-line>
        </div>
        <div *ngSwitchCase="'Speed'" class="position-relative">
            <app-common-line [widgetType]="'speed'" [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, widgetDataAttributes: widget?.dataAttributes, name: widget?.name}">
            </app-common-line>
        </div>
        <div *ngSwitchCase="'Engine Oil Pressure'" class="position-relative">
            <app-common-scatter-plot [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'', widgetDataAttributes: widget?.dataAttributes, name:widget?.name }">
            </app-common-scatter-plot>
        </div>
        <div *ngSwitchCase="'CNG Fuel Consumption'" class="position-relative">
            <app-common-scatter-plot [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'', widgetDataAttributes: widget?.dataAttributes, name:widget?.name}">
            </app-common-scatter-plot>
        </div>
        <div *ngSwitchCase="'LNG Consumption'" class="position-relative">
            <app-common-scatter-plot [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'', widgetDataAttributes: widget?.dataAttributes, name:widget?.name}">
            </app-common-scatter-plot>
        </div>
        <div *ngSwitchCase="'Power Consumption'" class="position-relative">
            <app-common-line [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, widgetDataAttributes: widget?.dataAttributes, name: widget?.name}">
            </app-common-line>
        </div>
        <div *ngSwitchCase="'Mileage'" class="position-relative">
            <app-common-line [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, widgetDataAttributes: widget?.dataAttributes, name: widget?.name}">
            </app-common-line>
        </div>
        <div *ngSwitchCase="'common-line'" class="position-relative">
            <app-common-line [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, widgetDataAttributes: widget?.dataAttributes, name: widget?.name}"
                [fromDate]="fromDate" [toDate]="toDate">
            </app-common-line>
        </div>
        <div *ngSwitchCase="'common-scatter'" class="position-relative">
            <app-common-scatter-plot [entityDetails]="masterEntitiesData" [entityId]="entityId"
                [widgetData]="{refreshRate:widget?.attributes?.refreshRate,title:widget?.title, entityType:'', widgetDataAttributes: widget?.dataAttributes, name:widget?.name}"
                [fromDate]="fromDate" [toDate]="toDate">
            </app-common-scatter-plot>
        </div>
        <div *ngSwitchDefault>
            <app-no-data-widget></app-no-data-widget>
        </div>
    </div>
    <div *ngIf="!widgetDetails?.length && !loader">
        <app-no-data-widget></app-no-data-widget>
    </div>
    <div *ngIf="loader">
        Loading widgets...
    </div>
</div>